<template>
  <div class="index">
    <div class="index_anlan_logo">
      <el-image src="/static/imgs/anlan-logo.png" class="index_logo_img"/>
    </div>
    <div class="index_navbar">
      <div class="index_nav_col" @click="toSearch" v-if="searchShow">
        <div class="index_nav_one">
          <img style="height:3rem;" :src="require('@/assets/imgs/ship_search.png')"/>
        </div>
        <div class="index_nav_title">船舶搜索</div>
      </div>
      <div class="index_nav_col" @click="toNews" v-if="newsShow">
        <div class="index_nav_one">
          <img style="height:3rem;" :src="require('@/assets/imgs/news.png')"/>
        </div>
        <div class="index_nav_title">航运新闻</div>
      </div>
      <div class="index_nav_col" @click="toIncidents" v-if="alarmShow">
        <div class="index_nav_one">
          <img style="height:3rem;" :src="require('@/assets/imgs/incident.png')"/>
        </div>
        <div class="index_nav_title">海事通告</div>
      </div>
      <div class="index_nav_col" @click="toReport" v-if="reportShow">
        <div class="index_nav_one">
          <img style="height:3rem;" :src="require('@/assets/imgs/report.png')"/>
        </div>
        <div class="index_nav_title">报案登记</div>
      </div>
      <div class="index_nav_col" @click="toInquiry" v-if="inquiryShow">
        <div class="index_nav_one">
          <img style="height:3rem;" :src="require('@/assets/imgs/inquiry.png')"/>
        </div>
        <div class="index_nav_title">保险询价</div>
      </div>
      <div class="index_nav_col" @click="toQuote" v-if="quoteShow">
        <div class="index_nav_one">
          <img style="height:3rem;" :src="require('@/assets/imgs/inquiry.png')"/>
        </div>
        <div class="index_nav_title">询价处理</div>
      </div>
      <div class="index_nav_col" @click="toUser" v-if="userShow">
        <div class="index_nav_one">
          <img style="height:3rem;" :src="require('@/assets/imgs/user.png')"/>
        </div>
        <div class="index_nav_title">个人信息</div>
      </div>
    </div>
    <div class="index_count_box">
      <el-carousel height="50px" direction="vertical" :autoplay="true" indicator-position="none">
        <el-carousel-item v-for="(item,index) in counts" :key="index">
          <div class="index_count_one">
            <div class="index_count_title">
              {{item.title}}
            </div>
            <div class="index_count_value">
              {{item.count}}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="index_footer">
      <div class="index_footer_one">
        <div class="index_footer_left">
          官方网站
        </div>
        <div class="index_footer_right">
          www.anlantech.cn
        </div>
      </div>
      <div class="index_footer_one">
        <div class="index_footer_left">
          客服邮箱
        </div>
        <div class="index_footer_right">
          ship@anlantech.cn
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getWebIndexCounts,querywxlogin,getUserPrivileges } from "../../api/api";
  import { getJsonStorage,setJsonStorage } from "../../util/storage";

  export default {
    name: "IndexIndex",
    data() {
      return {
        searchTimes: 0,
        progress: 0,
        counts: [],
        searchAble: true,
        searchShow: true,
        newsShow: true,
        newsAble: true,
        alarmShow: true,
        alarmAble: true,
        userShow: true,
        userAble:true,
        reportShow:false,
        reportAble:false,
        inquiryShow:false,
        inquiryAble:false,
        quoteShow:false,
        quoteAble:false,
        user:getJsonStorage('rfq_user'),
        privileges:getJsonStorage('rfq_privileges'),
        refererTitles: {'/pages/index/news_detail':'是否查看新闻','/pages/index/incident_detail':'是否查看通告','/pages/ship/info':'是否查看船舶','/pages/ship/detail':'是否查看船舶档案'}
      }
    },
    mounted(){
      if(this.$browserType===1){
        let ll = location.href.split("?");
        if(ll.length>1){
          querywxlogin(ll[1]);
        }
      }
      if(this.user){
        this.init();
      }
    },
    methods: {
      toNews(){
        this.$router.push('/index/news');
      },
      toIncidents(){
        this.$router.push('/index/incident');
      },
      toSearch(){
        this.$router.push('/index/ship');
      },
      toMissions(){
        this.$router.push('/user/missions');
      },
      toUser(){
        this.$router.push('/user/detail');
      },
      toReport(){
        this.$router.push('/report/index');
      },
      toInquiry(){
        this.$router.push('/inquiry/term');
      },
      toQuote(){
        this.$router.push('/quote/index');
      },
      init(){
        getUserPrivileges().then(res => {
          if(res && res.status === 0){
            setJsonStorage('rfq_privileges',res.data);
            this.privileges = res.data;
            for(let p in this.privileges.permissions){
              let pdata = JSON.parse(this.privileges.permissions[p].permission_data);
              if(this.privileges.permissions[p].permission_value === 'WXMP_index_ship_search'){
                this.searchAble = true;
                this.searchShow = pdata['show'];
                continue;
              }
              if(this.privileges.permissions[p].permission_value === 'WXMP_index_news'){
                this.newsAble = true;
                this.newsShow = pdata['show'];
                continue;
              }
              if(this.privileges.permissions[p].permission_value === 'WXMP_index_incident'){
                this.alarmAble = true;
                this.alarmShow = pdata['show'];
                continue;
              }
              if(this.privileges.permissions[p].permission_value === 'WXMP_index_report'){
                this.reportAble = true;
                this.reportShow = pdata['show'];
                continue;
              }
              if(this.privileges.permissions[p].permission_value === 'WXMP_index_inquiry'){
                this.inquiryAble = true;
                this.inquiryShow = pdata['show'];
                continue;
              }
              if(this.privileges.permissions[p].permission_value === 'WXMP_index_quote'){
                this.quoteAble = true;
                this.quoteShow = pdata['show'];
                continue;
              }
              if(this.privileges.permissions[p].permission_value === 'WXMP_index_user'){
                this.userAble = true;
                this.userShow = pdata['show'];
              }
            }
          }
        });
        getWebIndexCounts().then(res => {
          if(res && res.status===0){
            this.counts = res.data;
          }
        })
      }
    },
    watch:{
      "$route.query.url":{
        immediate:true,
        handler(url){
          if(url && url !== '' && url !== '/'){
            let href = decodeURIComponent(url);
            this.$router.push(href.substring(href.indexOf('#')+1));
          }
        }
      }
    }
  }
</script>

<style scoped>
  .index {
    position:absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100vh;
    background: linear-gradient(to bottom,#01dbdf,#0063c8);
  }

  .index_anlan_logo {
    width:90%;
    margin:8vh 0 12vh 10%;
    float:left;
  }

  .index_navbar {
    width:80%;
    height:5.4rem;
    margin:0 10%;
    text-align:center;
    float:left;
  }

  .index_nav_col {
    display:inline-block;
    width:18%;
    max-width:3.2rem;
    margin:.5rem 2%;
    text-align:center;
  }

  .index_nav_one {
    width:100%;
    position: relative;
    float:left;
    font-size: 3rem;
    height:3rem;
    line-height: 3rem;
    color: white;
    background-color: #03a7d5;
    border: 2px solid white;
    border-radius: .8rem;
  }

  .index_nav_title {
    font-size: .8rem;
    font-weight: bold;
    color:white;
  }

  .index_footer {
    position: absolute;
    width:100%;
    text-align: center;
    color: white;
    bottom:8vh;
  }

  .index_footer_one {
    height:1.5rem;
  }

  .index_counts {
    margin-top:1vh;
  }

  .index_count_box {
    position: absolute;
    width:80%;
    float:left;
    margin:68vh 10%;
    height:2rem;
    line-height:2rem;
    color:white;
    border-radius: .3rem;
    overflow: hidden;
    text-align: center;
  }

  .index_count_box_one {
    width:6rem;
    height:4rem;
    float:left;
    text-align: center;
    border:2px solid white;
    border-radius: 1rem;
    font-weight: bold;
    font-size: .9rem;
    margin: 0 .8rem;
  }

  .index_footer_left {
    width:38%;
    float:left;
    text-align: right;
    font-size: .9rem;
    color:#efefef;
  }

  .index_footer_right {
    width:60%;
    margin-left:2%;
    float:left;
    text-align: left;
    font-size: .9rem;
  }

  .index_count_title {
    width:52%;
    float:left;
    text-align: right;
  }

  .index_count_value {
    width:46%;
    float:right;
    text-align: left;
  }

  swiper {
    height: 3rem;
  }

  .index_logo_img {
    width:36%;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue